import React from 'react';
import WaterView from './WaterView';

export default (soid) => {
  return () => < WaterView serviceOfferingId={soid} />;
};
